import { API_URL } from '../constants/api_url';
import { checkLogin, logout } from './iam/session';
import { isFetching } from '../stores/isFetching';

export async function postContact(payload) {
  let isPrivateCall = payload.region && checkLogin();

  const token = sessionStorage.getItem('token');
  if (isPrivateCall && token === null) {
    isPrivateCall = false;
  }

  const HEADERS = {
    'Content-Type': 'application/vnd.api+json',
    ...(isPrivateCall ? { Authorization: `Bearer ${token}` } : {}),
  };

  isFetching.set(true);

  const BODY = JSON.stringify({
    data: {
      type: isPrivateCall ? 'support-private' : 'support-public',
      attributes: isPrivateCall
        ? payload
        : { tenantId: 'bayernwerk', ...payload },
    },
  });

  const res = await fetch(
    `${API_URL}/${isPrivateCall ? 'csc' : 'ova'}/support`,
    {
      method: 'POST',
      body: BODY,
      headers: HEADERS,
    }
  );

  isFetching.set(false);
  console.assert(res.ok);
  if (!res.ok) {
    if (res.statusCode === 401) {
      logout();
      return;
    } else {
      throw new Error('ERROR PROCESSING CONTACT');
    }
  }

  // Server will not send any body if HTTP 200 or 202.
  return;
}
